<script>
    import { navigate } from "svelte-routing";
    import Constantes from "../../Classes/Constantes";
    import Conexoes from "../../Classes/Conexoes";
    import { onMount } from "svelte";

    export let params;
   let cod_inscricao_encurtado= params;
    let api_atualiza_pagamento =
        Constantes.end_point_back_end_mercado_pago_atualiza;

    let parametros_pagamento = {
        cod_inscricao_encurtado: cod_inscricao_encurtado,
    };
    let pago = false;
    

    const downloadReceipt = () => {
        window.location.href =
            Constantes.api_gerar_comprovante + cod_inscricao_encurtado;
        
        navigate(Constantes.tela_minhas_incricoes);
    };

    const newSubscription = () => {
        navigate("/campeonatos");
    };

    async function updateStatus() {
        let conexao = new Conexoes();
        let result = await conexao.conecta(
            api_atualiza_pagamento,
            parametros_pagamento,
        );
        if (result) {
            let statusPagamento = result.status;
            if (
                statusPagamento === "approved" ||
                statusPagamento === "aprovado"
            ) {
                pago = true;
            }
        }
    }

    onMount(() => updateStatus());
</script>
{#if pago}
<div class="container">
    <div class="confirmation-box">
        <h1>Pagamento efetuado com sucesso!</h1>

        <div class="button-group">
            <button class="btn btn-primary" on:click={downloadReceipt}
                >Comprovante de inscrição</button
            >
            <button class="btn btn-primary" on:click={newSubscription}
                >Fazer nova inscrição</button
            >
        </div>
    </div>
</div>
{/if}
<style>
    .container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        background-color: #f5f5f5;
    }
    .confirmation-box {
        background-color: #28a745;
        color: white;
        padding: 2rem;
        border-radius: 10px;
        text-align: center;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
    .button-group {
        display: flex;
        justify-content: space-around;
        margin-top: 1rem;
        padding: 10px;
    }
</style>
